import { render, staticRenderFns } from "./SettingForm.vue?vue&type=template&id=6b89aab6&scoped=true"
import script from "./SettingForm.vue?vue&type=script&lang=js"
export * from "./SettingForm.vue?vue&type=script&lang=js"
import style0 from "./SettingForm.vue?vue&type=style&index=0&id=6b89aab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89aab6",
  null
  
)

export default component.exports